import { ChevronLeft } from 'lucide-react';
import { useIsNative, usePlatformNavigation } from '../../lib/platform';

interface NativeBackButtonProps {
  className?: string;
}

/**
 * Back button that only displays when running inside a native app.
 * Uses the native bridge to navigate back.
 */
export function NativeBackButton({ className = '' }: NativeBackButtonProps) {
  const isNative = useIsNative();
  const navigation = usePlatformNavigation();

  if (!isNative) {
    return null;
  }

  return (
    <button
      onClick={() => navigation.goBack()}
      className={`inline-flex items-center gap-1 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors ${className}`}
      aria-label="Go back"
    >
      <ChevronLeft className="w-5 h-5" />
      <span>Back</span>
    </button>
  );
}
